import React, { useState } from 'react';
import * as DateFns from 'date-fns';
import { DropdownButton } from 'react-bootstrap';
import { Collapse } from 'antd';

import PracticeBadge from '../MonthSchedule/PracticeBadge/PracticeBadge';
import GameBadge from '../MonthSchedule/GameBadge/GameBadge';
import Badge from '../Badge/Badge';
import { TooltipPropsType } from './types';
import { PRACTICE } from '../../../config/constants';

import './styles.scss';
const { Panel } = Collapse;

export const Tooltip = ({ moreEvents, tooltipData, margin }: TooltipPropsType) => {
  const [openMobile, setOpenMobile] = useState(false);
  if (moreEvents.length <= 0) {
    return <div>no tooltip</div>;
  }
  const marginHandlers: { [key: number]: boolean } = {};
  const marginProcess = (index: number, size: number) => {
    if (!Object.prototype.hasOwnProperty.call(marginHandlers, index)) {
      marginHandlers[index] = margin ? index === size - 1 : margin;
    }
    return marginHandlers[index];
  };
  const badgeEvents: JSX.Element[] = [];
  moreEvents.forEach((event, index) => {
    if (event.type === PRACTICE) {
      badgeEvents.push(
        <PracticeBadge
          practice={event}
          key={index}
          tooltipData={tooltipData}
          margin={marginProcess(index, moreEvents.length)}
        />
      );
    } else {
      badgeEvents.push(
        <GameBadge
          game={event}
          key={index}
          tooltipData={tooltipData}
          margin={marginProcess(index, moreEvents.length)}
        />
      );
    }
  });
  //const key = dateFns.format(new Date(moreEvents[0].startTime), "yyyyMMdd");
  return (
    <div className="sub-menu-tooltip collapse-schedule">
      {/*<ButtonToolbar>*/}
      <DropdownButton
        drop={(DateFns.isSaturday(moreEvents[0].startTime) || DateFns.isFriday(moreEvents[0].startTime)) ? 'left' : 'right'}
        // drop={(true) ? 'right' : 'left'}
        // variant="secondary"
        title={
          <Badge
            past={DateFns.isPast(moreEvents[moreEvents.length - 1].startTime)}
            tooltip={true}
            style={{ width: '100%' }}
          >
            <div className={'left'}>
              <div className={'dot'} />
              <div className={'dot'} />
              <div className={'dot'} />
              {` +${moreEvents.length}`}
            </div>
          </Badge>
        }
        id={`dropdown-button-drop`}
        className="tool-tip-dropdown-toggle"
      >
        <div className="dropdown-menu-content scroll-style-zebra-sports">{badgeEvents}</div>
      </DropdownButton>
      {/*</ButtonToolbar>*/}


      {/*<Dropdown show={showToolTip === key}*/}
      {/*          onToggle={() => showToolTip === key ? setShowToolTip(-1) : setShowToolTip(key)}>*/}
      {/*  <Dropdown.Toggle className="tool-tip-dropdown-toggle" drop={'left'}>*/}
      {/*    <Badge past={dateFns.isPast(moreEvents[moreEvents.length - 1].startTime)} tooltip={true} style={{width: '100%'}}>*/}
      {/*      <div className={'left'}>*/}
      {/*        <div className={'dot'}/>*/}
      {/*        <div className={'dot'}/>*/}
      {/*        <div className={'dot'}/>*/}
      {/*        {` +${moreEvents.length}`}*/}
      {/*      </div>*/}
      {/*    </Badge>*/}
      {/*  </Dropdown.Toggle>*/}
      {/*  <Dropdown.Menu*/}
      {/*    // className={`sub-menu-tooltip-body-${dateFns.isSaturday(moreEvents[0].startTime) || dateFns.isFriday(moreEvents[0].startTime) ? 'left' : 'right'}${isFirstWeek ? '-first' : ''}`}*/}
      {/*    style={{*/}
      {/*      padding: '0',*/}
      {/*      minWidth: '162px',*/}
      {/*      borderRadius: '0',*/}
      {/*      margin: '0',*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    /!*<div*!/*/}
      {/*    /!*  className={`sub-menu-tooltip-body-${dateFns.isSaturday(moreEvents[0].startTime) || dateFns.isFriday(moreEvents[0].startTime) ? 'left' : 'right'}${isFirstWeek ? '-first' : ''}`}*!/*/}
      {/*    /!*  onClickCapture={(e) => {*!/*/}
      {/*    /!*  }} onMouseOut={(e) => {*!/*/}
      {/*    /!*}}>*!/*/}
      {/*      {badgeEvents}*/}
      {/*    /!*</div>*!/*/}
      {/*  </Dropdown.Menu>*/}
      {/*</Dropdown>*/}


      {/*<div onClick={() => showToolTip === key ? setShowToolTip(-1) : setShowToolTip(key)}>*/}
      {/*  <Badge past={dateFns.isPast(moreEvents[moreEvents.length - 1].startTime)} tooltip={true}>*/}
      {/*    <div className={'left'}>*/}
      {/*      <div className={'dot'}/>*/}
      {/*      <div className={'dot'}/>*/}
      {/*      <div className={'dot'}/>*/}
      {/*      {` +${moreEvents.length}`}*/}
      {/*    </div>*/}
      {/*  </Badge>*/}
      {/*</div>*/}
      {/*{showToolTip === key ?*/}
      {/*  <div*/}
      {/*    className={`sub-menu-tooltip-body-${dateFns.isSaturday(moreEvents[0].startTime) || dateFns.isFriday(moreEvents[0].startTime) ? 'left' : 'right'}${isFirstWeek ? '-first' : ''}`}*/}
      {/*    onClickCapture={(e) => {*/}
      {/*    }} onMouseOut={(e) => {*/}
      {/*  }}>*/}
      {/*    {badgeEvents}*/}
      {/*  </div> : null*/}
      {/*}*/}
      <div onClick={() => setOpenMobile(!openMobile)}>
        <Collapse>
        <Panel header={
                      <div className={'left'}>
                        <div className={'dot'} />
                        <div className={'dot'} />
                        <div className={'dot'} />
                        { openMobile ?'':` +${moreEvents.length}`}
                      </div>
                      }
              key="1"
        >
          {badgeEvents}
        </Panel>
        
      </Collapse>
      </div>
    </div>
  );
};

export default Tooltip;
